import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';
import { LoadingRow } from './style';

interface LoadingProps {
  height?: number;
  spinSize?: React.ComponentProps<typeof Spin>['size'];
  error?: {
    message: string;
  };
}

const Loading = function ({
  height = 50,
  spinSize = 'medium',
  error,
}: LoadingProps) {
  return (
    <LoadingRow justify="center" $height={height}>
      <Spin
        size={spinSize}
        indicator={error ? <ExclamationCircleOutlined /> : undefined}
      />
    </LoadingRow>
  );
};

export default Loading;
